import { appConfig } from '../config';

export const api = {
    fetchFaqs: () => import('axios').then((axios) => axios.get(`${appConfig.API}faqs`)),
    fetchShops: (terms) => import('axios').then((axios) => axios.get(`${appConfig.API}shops/${terms}`)),
};
